<template>
  <div style="padding: 100px 20px 0 80px;">
    <!-- {{courtier}} -->

    <a-button
      type="primary"
      @click="page = 'courtier'"
      shape="round"
      :ghost="page != 'courtier'"
      style="margin-right: 10px"
    >
      Mes informations
    </a-button>
    <a-button
      v-if="isRootBroker"
      type="primary"
      @click="page = 'users'"
      shape="round"
      :ghost="page != 'users'"
    >
      Habilitation
    </a-button>

    <a-divider></a-divider>

    <div v-if="page == 'courtiear'" class="u_main">
      <div class="u_main_name">
        <div class="u_img">
          <img alt="Courtier" src="../assets/user.png" />
        </div>
        <div class="u_name">
          <strong>{{ courtier.first_name }} {{ courtier.last_name }}</strong>
          <br />
          <span>
            <strong>{{ courtier.identity }} {{ courtier.name }}</strong>
          </span>
          -
          <span>
            <em>{{ courtier.internal_number }}</em>
          </span>
        </div>
      </div>

      <div v-if="changeWhat == 'INFO'">
        <div>
          <div>
            <label>Adresse</label>
            <a-input :disabled="!editMode" v-model:value="courtier.address" />
          </div>
          <div>
            <label>Adresse complémentaire</label>
            <a-input
              :disabled="!editMode"
              v-model:value="courtier.additional_address"
            />
          </div>
        </div>
        <div>
          <div>
            <label>Code postal</label>
            <a-input :disabled="!editMode" v-model:value="courtier.zip_code" />
          </div>
          <div>
            <label>Ville</label>
            <a-input :disabled="!editMode" v-model:value="courtier.city" />
          </div>
        </div>
        <div>
          <div>
            <label>Téléphone portable</label>
            <a-input
              :disabled="!editMode"
              v-model:value="courtier.tel_mobile"
            />
          </div>
          <div>
            <label>Téléphone fixe</label>
            <a-input :disabled="!editMode" v-model:value="courtier.tel_home" />
          </div>
        </div>
        <div>
          <div>
            <label>Adresse mail</label>
            <a-input :disabled="true" v-model:value="courtier.email" />
          </div>
        </div>
      </div>

      <div v-if="editMode && changeWhat == 'PASS'">
        <div>
          <label>Ancien mot de passe</label>
          <a-input type="password" v-model:value="pass.old" />
        </div>
        <div>
          <label>Nouveau mot de passe</label>
          <a-input type="password" v-model:value="pass.passOne" />
        </div>
        <div>
          <label>Confirmer votre mot de passe</label>
          <a-input type="password" v-model:value="pass.passTwo" />
        </div>
      </div>

      <br />

      <a-button
        type="primary"
        shape="round"
        ghost
        v-if="!editMode"
        @click="edit('INFO')"
      >
        Modifier mes informations
      </a-button>
      <a-button
        type="primary"
        shape="round"
        ghost
        v-if="!editMode"
        @click="edit('PASS')"
      >
        Changer de mot de passe
      </a-button>

      <a-button
        type="primary"
        shape="round"
        ghost
        v-if="editMode"
        @click="save()"
      >
        Envoyer
      </a-button>
      <a-button
        type="default"
        shape="round"
        ghost
        danger
        v-if="editMode"
        @click="cancel()"
      >
        Annuler
      </a-button>

      <div v-if="showMessage" id="message">{{ messageText }}</div>
      <div v-if="showErrorMessage" id="errorMessage">
        {{ errorMessageText }}
      </div>
    </div>

    <div style="width: 600px; margin: auto">
      <template v-if="page == 'courtier'">
        <MyInfo />
      </template>
      <template v-if="page == 'users'">
        <Habilitation />
      </template>
    </div>
  </div>
</template>

<script>
import MyInfo from "./../components/profile/MyInfo.vue";
import Habilitation from "./../components/profile/Habilitation.vue";
export default {
  name: "docs",
  components: { Habilitation, MyInfo },
  data: () => {
    return {
      editMode: false,
      page: "courtier",
      add_form: false,

      showMessage: false,
      messageText: "",

      showErrorMessage: false,
      errorMessageText: "",

      changeWhat: "INFO",

      originalInfo: [],

      pass: {
        old: "",
        passOne: "",
        passTwo: "",
      },

      co: {
        id: null,
        mailCourtier: "",
        prenomCourtier: "",
        nomCourtier: "",
        telP: "",
        telF: "",
      },
    };
  },
  watch: {},
  methods: {
    reset() {
      this.pass.old = "";
      this.pass.passOne = "";
      this.pass.passTwo = "";
    },
    cancel() {
      this.reset();
      this.editMode = false;
      this.changeWhat = "INFO";

      this.showMessage = false;
      this.showErrorMessage = false;

      this.courtier.adresse = this.originalInfo.adresse;
      this.courtier.adresse_suite = this.originalInfo.adresse_suite;
      this.courtier.cp = this.originalInfo.cp;
      this.courtier.ville = this.originalInfo.ville;
      this.courtier.tel_p = this.originalInfo.tel_p;
      this.courtier.tel_f = this.originalInfo.tel_f;
    },
    edit(what) {
      this.changeWhat = what;
      this.editMode = true;
    },
    save() {
      this.showErrorMessage = false;

      if (this.changeWhat == "PASS") {
      }

      this.axios
        .post("modifCourtier", {
          courtier: this.courtier,
          pass: this.pass,
          changeWhat: this.changeWhat,
        })
        .then((r) => {
          if (r.data.status == false) {
            this.showErrorMessage = true;
            this.errorMessageText = r.data.errorMessage;
            return;
          }

          if (r.data.status == true) {
            this.showMessage = true;

            if (this.changeWhat == "INFO")
              this.messageText =
                "Votre demande sera traitée dans les meilleurs délais";
            if (this.changeWhat == "PASS")
              this.messageText = "Votre mot de passe a été modifié";

            this.editMode = false;
            this.changeWhat = "INFO";

            setTimeout(() => {
              this.showMessage = false;
            }, 5000);

            this.reset();
          }
        });
    },
    addCoUser() {
      this.errorMessageText = "";

      this.co = new Object();

      this.co.id = null;
      this.co.mailCourtier = "";
      this.co.prenomCourtier = "";
      this.co.nomCourtier = "";
      this.co.telP = "";
      this.co.telF = "";
      this.add_form = true;
    },
    createCoUser() {
      this.errorMessageText = "";
      this.axios.post("createCoUser", this.co).then((r) => {
        if (r.data.status == true) {
          if (this.co.id == null) {
            this.$store.state.coBrokers.push({
              id: r.data.id,
              mailCourtier: this.co.mailCourtier,
              prenomCourtier: this.co.prenomCourtier,
              nomCourtier: this.co.nomCourtier,
              telP: this.co.telP,
              telF: this.co.telF,
              active: "0",
            });
          }
          this.add_form = false;
        }
        if (r.data.status == false) {
          this.errorMessageText = r.data.errorMesage;
        }
      });
    },
    editCoUser(id) {
      this.users.filter((u) => {
        if (id == u.id) this.co = u;
      });
      this.add_form = true;
    },
    deleteCoUser(id) {
      var r = confirm("Êtes-vous sûr ?");
      if (r == true) {
        this.axios.post("deleteCoUser/" + id).then((r) => {
          if (r.data.status == true) {
            this.users.filter((u, k) => {
              if (id == u.id) this.users.splice(k, 1);
            });
          }
          if (r.data.status == false) {
            console.log("error");
          }
        });
      }
    },
    cancelCo() {
      this.add_form = false;
    },
  },
  computed: {
    courtier() {
      return this.$store.getters.broker;
    },
    isRootBroker() {
      return this.courtier.type === "ROOT";
    },
    users() {
      return this.$store.state.coBrokers;
    },
  },
  mounted() {
    Object.assign(this.originalInfo, this.courtier);
  },
};
</script>
<style media="screen">
div#message {
  padding: 10px 0;
  color: green;
}

div#errorMessage {
  padding: 10px 0;
  color: red;
}

.ant-list-split .ant-list-item {
  border-bottom: 1px solid black;
}
</style>
